import { createApi } from "@reduxjs/toolkit/query/react";
import {
  createBaseQuery,
  createServerSideRequestOption,
  getBaseUrl,
} from "../config";

export const getAuthenticatedUser = async (request: Request) => {
  return await createServerSideRequestOption({
    url: `${getBaseUrl()}/api/v1/user/me`,
    request: request,
    method: "GET",
  });
};

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: createBaseQuery("/user"),
  tagTypes: ["authApi"],
  endpoints: (build) => ({
    login: build.mutation<User, LoginData>({
      query: (body) => ({
        url: "/login",
        method: "POST",
        body,
      }),
    }),
    logout: build.mutation<void, void>({
      query: (body) => ({
        url: "/logout",
        method: "GET",
        body,
      }),
    }),
  }),
});
